/**
 * ChartSummary — Visually-hidden but screen-reader-readable text summary
 * for charts/sparklines. Sits adjacent to a recharts/SVG visualization so
 * AT users get a plain-text version of what sighted users see.
 *
 * Usage:
 *   <ChartSummary
 *     title="Top Skill Areas (engagement)"
 *     items={[{ label: "Critical thinking", value: 18 }, ...]}
 *     unit=""           // e.g., "%", "students"
 *     emptyText="No data yet."
 *   />
 *
 * Use in tandem with role="img" + aria-label on the chart wrapper:
 *   <div role="img" aria-label="Bar chart showing top skill engagement">
 *     <ChartSummary ... />
 *     <BarChart ... />
 *   </div>
 *
 * Keep this component < 50 lines and avoid any logic — just a list reader.
 */
export default function ChartSummary({ title, items = [], unit = "", emptyText = "No data yet.", testId }) {
  if (!items || items.length === 0) {
    return (
      <p className="sr-only" data-testid={testId}>
        {title}: {emptyText}
      </p>
    );
  }
  return (
    <div className="sr-only" data-testid={testId}>
      <p>{title} — text summary:</p>
      <ul>
        {items.map((it, i) => (
          <li key={i}>
            {it.label}: {it.value}{unit}
            {it.note ? `. ${it.note}` : ""}
          </li>
        ))}
      </ul>
    </div>
  );
}
